import { ApolloLink } from 'apollo-link';

import { COUNTRY_PREFIX } from '../../CONSTANTS';

const currencyLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'Creh-Country': COUNTRY_PREFIX,
    },
  }));

  return forward(operation);
});

export default currencyLink;
